module.exports = __webpack_public_path__ + "static/media/microBlog.0d7b7c6d.png";